import {onFind} from "@elements/init-modules-in-scope";
import {addClass} from "@elements/dom-utils";

export function init () {
    onFind('.wysiwyg table', function ($element) {

        let el = $element;
        let wrapper = document.createElement('div');
        addClass('table-responsive-lg', wrapper);
        addClass('table-wrapper', wrapper);
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el)

    });
}
